export default {
  // Tab names
  'tab.main': '主頁',
  'tab.producers': '生產器',
  'tab.achievements': '成就',
  'tab.prestige': '轉生',
  'tab.settings': '設定',

  // Header
  'header.bps': '/秒',
  'header.stage': '階段',
  'header.tap': 'TAP!',

  // Combo
  'combo.nice': 'Nice!',
  'combo.great': 'Great!',
  'combo.amazing': 'Amazing!',
  'combo.incredible': 'INCREDIBLE!',
  'combo.legendary': 'LEGENDARY!',
  'combo.label': '連擊',

  // Critical
  'crit.label': 'CRITICAL!',

  // Producers
  'producer.P1': '種子',
  'producer.P2': '嫩芽',
  'producer.P3': '幼苗',
  'producer.P4': '咖啡樹',
  'producer.P5': '小農場',
  'producer.P6': '大農場',
  'producer.P7': '烘焙坊',
  'producer.P8': '咖啡工廠',
  'producer.P9': '出口中心',
  'producer.P10': '加盟店',
  'producer.P11': '咖啡帝國',
  'producer.P12': '咖啡星球',

  // Tap upgrades
  'upgrade.T1': '靈巧手指',
  'upgrade.T2': '手套',
  'upgrade.T3': '工具',
  'upgrade.T4': '機械',
  'upgrade.T5': '機器人',
  'upgrade.T6': '奈米科技',
  'upgrade.T7': '量子收穫',
  'upgrade.T8': '時間扭曲',

  // Prestige upgrades
  'prestige.G1': '黃金種子',
  'prestige.G1.desc': 'BPS +1 基礎',
  'prestige.G2': '肥沃土壤',
  'prestige.G2.desc': '點擊力量 x1.5',
  'prestige.G3': '新手折扣',
  'prestige.G3.desc': 'P1~P3 費用 -50%',
  'prestige.G4': '連夜生長',
  'prestige.G4.desc': '離線效率 +20%',
  'prestige.G5': '速成栽培',
  'prestige.G5.desc': '全部 BPS x2',
  'prestige.G6': '幸運之手',
  'prestige.G6.desc': '暴擊機率 +3%',
  'prestige.G7': '咖啡大師',
  'prestige.G7.desc': '點擊力量 x3',
  'prestige.G8': '批發折扣',
  'prestige.G8.desc': '全部費用 -20%',
  'prestige.G9': '快速開始',
  'prestige.G9.desc': 'P1~P3 10個起步',
  'prestige.G10': '精品調配',
  'prestige.G10.desc': '全部 BPS x3',
  'prestige.G11': '時光之豆',
  'prestige.G11.desc': '離線效率 100%',
  'prestige.G12': '咖啡王之冠',
  'prestige.G12.desc': '全部產量 x2',
  'prestige.G13': '金豆之樹',
  'prestige.G13.desc': '金豆獲取 +20%',
  'prestige.G14': '時光旅行',
  'prestige.G14.desc': '從第5階段開始',
  'prestige.G15': '無限之豆',
  'prestige.G15.desc': '全部產量 x10',
  'prestige.G16': '咖啡大爆炸',
  'prestige.G16.desc': '金豆獲取 x2',

  // Star upgrades
  'star.S1': '啟動資金',
  'star.S1.desc': '起始100萬豆',
  'star.S2': '永恆黃金',
  'star.S2.desc': '金豆獲取 x2 永久',
  'star.S3': '星之祝福',
  'star.S3.desc': '全部 BPS x5 永久',
  'star.S4': '自動點擊',
  'star.S4.desc': '每秒1次自動點擊',
  'star.S5': '連擊大師',
  'star.S5.desc': '連擊維持時間 3秒',
  'star.S6': '致命一擊',
  'star.S6.desc': '暴擊倍率 x2',
  'star.S7': '宇宙之力',
  'star.S7.desc': '全部產量 x10 永久',
  'star.S8': '超越之星',
  'star.S8.desc': '升天加成 x3',

  // Varieties
  'variety.V1': '阿拉比卡',
  'variety.V2': '羅布斯塔',
  'variety.V3': '賴比瑞亞',
  'variety.V4': '依索比亞',
  'variety.V5': '藝伎',
  'variety.V6': '麝香貓咖啡',
  'variety.V7': '藍山',
  'variety.V8': '可納',
  'variety.V9': '耶加雪菲',
  'variety.V10': '圓豆',
  'variety.V11': '象豆',
  'variety.V12': '聖乘赫勒拿',

  // Stages
  'stage.1': '奶奶的花園',
  'stage.2': '小院子',
  'stage.3': '咖啡農場',
  'stage.4': '烘焙坊',
  'stage.5': '咖啡工廠',
  'stage.6': '全球連鎖',
  'stage.7': '咖啡王國',

  // Roasting
  'roast.perfect': '完美烘焙！',
  'roast.dark': '深焙',
  'roast.medium': '中焙',
  'roast.light': '淺焙',
  'roast.burnt': '燒焦了...',
  'roast.raw': '還沒熟',
  'roast.tap': '點擊停止！',
  'roast.reward': '獎勵',
  'roast.double': '看廣告獲得2倍！',
  'roast.collect': '領取',

  // Achievements
  'ach.tap1': '第一步', 'ach.tap1.desc': '點擊100次',
  'ach.tap2': '勤勞的手', 'ach.tap2.desc': '點擊1,000次',
  'ach.tap3': '點擊大師', 'ach.tap3.desc': '點擊10,000次',
  'ach.tap4': '傳說之指', 'ach.tap4.desc': '點擊100,000次',
  'ach.tap5': '點擊之神', 'ach.tap5.desc': '點擊1,000,000次',
  'ach.tap6': '快手', 'ach.tap6.desc': '每秒5次點擊',
  'ach.tap7': '閃電手', 'ach.tap7.desc': '每秒10次點擊',
  'ach.tap8': '神之手', 'ach.tap8.desc': '每秒15次點擊',
  'ach.tap9': '連擊狂人', 'ach.tap9.desc': '達成20連擊',
  'ach.tap10': '傳說連擊', 'ach.tap10.desc': '達成50連擊',

  'ach.prod1': '首次收穫', 'ach.prod1.desc': '累計收穫1千豆',
  'ach.prod2': '小有成就', 'ach.prod2.desc': '累計收穫10萬豆',
  'ach.prod3': '成長中的農場', 'ach.prod3.desc': '累計收穫1千萬豆',
  'ach.prod4': '咖啡大亨', 'ach.prod4.desc': '累計收穫10億豆',
  'ach.prod5': '咖啡皇帝', 'ach.prod5.desc': '累計收穫1兆豆',
  'ach.prod6': '自動化開始', 'ach.prod6.desc': '達到 BPS 100',
  'ach.prod7': '工廠運轉', 'ach.prod7.desc': '達到 BPS 1萬',
  'ach.prod8': '工業革命', 'ach.prod8.desc': '達到 BPS 100萬',
  'ach.prod9': '全球產量', 'ach.prod9.desc': '達到 BPS 1億',
  'ach.prod10': '宇宙級產量', 'ach.prod10.desc': '達到 BPS 100億',

  'ach.bld1': '新手農夫', 'ach.bld1.desc': 'P1~P4 各擁有1個',
  'ach.bld2': '中級農夫', 'ach.bld2.desc': 'P1~P8 各擁有1個',
  'ach.bld3': '大師農夫', 'ach.bld3.desc': '擁有所有生產器',
  'ach.bld4': '集中投資', 'ach.bld4.desc': '單一種類擁有10個',
  'ach.bld5': '大量購買', 'ach.bld5.desc': '單一種類擁有25個',
  'ach.bld6': '收藏家', 'ach.bld6.desc': '單一種類擁有50個',
  'ach.bld7': '壟斷王', 'ach.bld7.desc': '單一種類擁有100個',
  'ach.bld8': '事業擴張', 'ach.bld8.desc': '共100個生產器',
  'ach.bld9': '企業帝國', 'ach.bld9.desc': '共500個生產器',
  'ach.bld10': '征服世界', 'ach.bld10.desc': '共1000個生產器',

  'ach.pres1': '首次轉生', 'ach.pres1.desc': '轉生1次',
  'ach.pres2': '重複的滋味', 'ach.pres2.desc': '轉生3次',
  'ach.pres3': '轉生大師', 'ach.pres3.desc': '轉生5次',
  'ach.pres4': '無盡循環', 'ach.pres4.desc': '轉生10次',
  'ach.pres5': '永恆之環', 'ach.pres5.desc': '轉生20次',
  'ach.pres6': '輪迴達人', 'ach.pres6.desc': '轉生50次',
  'ach.pres7': '黃金收穫', 'ach.pres7.desc': '一次獲得10金豆',
  'ach.pres8': '黃金風暴', 'ach.pres8.desc': '一次獲得100金豆',
  'ach.pres9': '速通玩家', 'ach.pres9.desc': '30分鐘內轉生',
  'ach.pres10': '閃電轉生', 'ach.pres10.desc': '15分鐘內轉生',

  'ach.spec1': '櫻桃獵人', 'ach.spec1.desc': '點擊金櫻桃1次',
  'ach.spec2': '櫻桃狂人', 'ach.spec2.desc': '點擊金櫻桃10次',
  'ach.spec3': '櫻桃大師', 'ach.spec3.desc': '點擊金櫻桃50次',
  'ach.spec4': '烘焙入門', 'ach.spec4.desc': '完美烘焙1次',
  'ach.spec5': '烘焙達人', 'ach.spec5.desc': '完美烘焙10次',
  'ach.spec6': '品種收藏家', 'ach.spec6.desc': '收集5種品種',
  'ach.spec7': '咖啡博士', 'ach.spec7.desc': '收集全部12種品種',
  'ach.spec8': '勤奮農夫', 'ach.spec8.desc': '累計遊玩1小時',
  'ach.spec9': '咖啡成癮', 'ach.spec9.desc': '累計遊玩24小時',
  'ach.spec10': '連續7天', 'ach.spec10.desc': '連續7天登入',

  'ach.mile1': '咖啡農場主', 'ach.mile1.desc': '到達第3階段',
  'ach.mile2': '咖啡企業家', 'ach.mile2.desc': '到達第5階段',
  'ach.mile3': '咖啡之王', 'ach.mile3.desc': '到達第7階段',
  'ach.mile4': '超越者', 'ach.mile4.desc': '首次星之升天',
  'ach.mile5': '完美主義者', 'ach.mile5.desc': '達成50項成就',

  // Achievement categories
  'ach.cat.tapping': '點擊',
  'ach.cat.production': '生產',
  'ach.cat.producers': '生產器',
  'ach.cat.prestige': '轉生',
  'ach.cat.special': '特殊',
  'ach.cat.milestone': '里程碑',

  // Prestige panel
  'prestige.title': '烘焙轉生',
  'prestige.desc': '轉生獲得金豆，從頭開始更強大！',
  'prestige.goldenBeans': '金豆',
  'prestige.expected': '預計獲得',
  'prestige.rebirth': '轉生',
  'prestige.upgrades': '轉生升級',
  'prestige.locked': '到達第7階段解鎖',
  'prestige.adBonus': '看廣告 +30%',

  // Ascension panel
  'ascend.title': '星之升天',
  'ascend.desc': '升天獲得星塵，超越一切！',
  'ascend.starDust': '星塵',
  'ascend.expected': '預計獲得',
  'ascend.ascend': '升天',
  'ascend.upgrades': '星之升級',
  'ascend.locked': '需要轉生10次 + 100金豆',

  // Settings
  'settings.bgm': '背景音樂',
  'settings.sfx': '音效',
  'settings.vibration': '震動',
  'settings.language': '語言',
  'settings.reset': '重置資料',
  'settings.resetConfirm': '確定要刪除所有資料嗎？',
  'settings.credits': '製作團隊',
  'settings.version': '版本',

  // Boost buttons
  'boost.tap': '點擊加成',
  'boost.bps': '生產加成',

  // Offline
  'offline.title': '歡迎回來！',
  'offline.earned': '離線收益',
  'offline.time': '離開時間',
  'offline.collect': '領取',
  'offline.adX3': '看廣告 x3',

  // General
  'buy': '購買',
  'max': '最大',
  'level': 'Lv.',
  'locked': '鎖定',
  'owned': '擁有',
  'on': '開',
  'off': '關',
} as const;
